import { useContext, useState } from "react";
import { Context } from "../../../context/Context";
import { Button, Megaphone } from "../../ui";
import { EDITABLE_STATUSES } from "../operationUtils";
import { getCampaignText } from "./campaignActionsText";
import CampaignModal from "./CampaignModal";
import EditCampaignModal from "./EditCampaignModal";
import RequestStatusList from "./RequestStatusList";

// Every restaurant's Operations request for one campaign: current status
// (straight from Operations), dates, and editing of the dates while the
// lifecycle still allows it.
export default function CampaignRequestsModal({ campaign, requests, storeNames, canEdit, onClose, onChanged, onViewInOperations, onBack }) {
  const { lang } = useContext(Context);
  const text = getCampaignText(lang);
  const [editing, setEditing] = useState(null);

  const rows = requests.map((request) => ({
    key: request._id,
    store: storeNames[request.storeId] || request.storeId,
    status: request.status,
    startDate: request.startDate,
    endDate: request.endDate,
    action: request,
  }));

  return (
    <>
      <CampaignModal
        title={text.requestsTitle + " — " + campaign.title}
        icon={<Megaphone size={20} aria-hidden="true" />}
        onClose={onClose}
        closeLabel={text.close}
        footer={
          <>
            {onBack && (
              <Button variant="neutral" appearance="soft" onClick={onBack}>
                {text.backToList}
              </Button>
            )}
            {requests.length > 0 && (
              <Button variant="primary" appearance="filled" onClick={() => onViewInOperations(requests)}>
                {text.viewInOperations}
              </Button>
            )}
            <Button variant="neutral" appearance="soft" onClick={onClose}>
              {text.close}
            </Button>
          </>
        }
      >
        {rows.length === 0 ? (
          <p className="ca-picker-state">{text.noRequests}</p>
        ) : (
          <RequestStatusList
            rows={rows}
            renderExtra={(row) => (
              <>
                {canEdit && EDITABLE_STATUSES.includes(row.status) && (
                  <Button size="sm" appearance="soft" variant="neutral" onClick={() => setEditing(row.action)}>
                    {text.editDates}
                  </Button>
                )}
                <Button size="sm" appearance="ghost" onClick={() => onViewInOperations([row.action])}>
                  {text.viewInOperations}
                </Button>
              </>
            )}
          />
        )}
      </CampaignModal>

      {editing && (
        <EditCampaignModal
          action={editing}
          // the restaurants this list already knows (public ids)
          stores={Object.keys(storeNames || {}).map((id) => ({ id }))}
          onClose={() => setEditing(null)}
          onSaved={() => onChanged()}
        />
      )}
    </>
  );
}
